export default __webpack_public_path__ + "static/media/tip2a.fbbb3660.png";